import AppConfig from 'api/AppConfig';
import axios from 'axios';
import useDataFetchFunction from 'hooks/useDataFetchFunction';
import React from 'react'
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import TransactionTimeline from './TransactionTimeline';
import InvoiceContainer from './InvoiceContainer';
import { useState } from 'react';
import { getTransactionHistoryUrl } from 'api/hiredrateURLConstruct';

const TransactionHistory = () => {
    const { customerId } = useSelector((state) => state.account);
    const configObject = AppConfig("APIConfig");

    const [selectedTransaction, setSelectedTransaction] = useState(null);
    const [viewMode, setViewMode] = useState('list'); // 'list' | 'invoice'
    //   const { customerId } = useSelector((state) => state.account);

    const [
        transactionDetails,
        transactionDetailsError,
        transactiondetails,
        fetchTransactionDetails,
    ] = useDataFetchFunction()

    const getTransactionDetails = () => {
        fetchTransactionDetails({
            axiosInstance: axios,
            method: "get",
            url: getTransactionHistoryUrl(customerId),
            requestConfig: configObject,
        });
    };

    useEffect(() => {
        getTransactionDetails();
    }, [])


    const handleRowClick = (transaction) => {
        setSelectedTransaction(transaction);
        setViewMode('invoice');
    };

    const handleBack = () => {
        setViewMode('list');
        setSelectedTransaction(null);
    };
    return (
        <div>
            {viewMode === 'list' ? (
                <TransactionTimeline
                    transactions={transactionDetails?.transactions}
                    onRowClick={handleRowClick}
                />
            ) : (
                <InvoiceContainer
                    transactionId={selectedTransaction?.transaction_id}
                    customerId={customerId}
                    onBack={handleBack}
                    onClose={handleBack}
                />
            )}
        </div>
    )
}

export default TransactionHistory
